import React from "react";

// Components
import Home from "./pages/Home";

function App() {
    return (
        <div className="w-full min-h-screen bg-slate-100">
            <Home />
        </div>
    );
}

export default App;
